import { Config } from "./config";

export const stagingConfig: Config = {
	Sentry: undefined
}
